import './sms.less';
import React from 'react';
import {inject, observer} from 'mobx-react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {SmsSend} from './sms-send';
import {SmsList} from './sms-list';


@inject("loginStore")
@observer
export class Sms extends React.Component {

  componentDidMount() {
  }

  render() {
    return (
      <Switch>
        <Route path="/crm/sms/send" component={SmsSend} />
        <Route exact path="/crm/sms/" component={SmsList} />
        <Redirect to="" />
      </Switch>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/crm/sms/sms.js